/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import * as React from 'react';

import { ApprovalRequestType } from '../../../../data/types.generated';
import { LogCategory } from '../../../../logger';
import { getAppHost } from '../../../../utilities/TeamsUtils';
import { Spinner } from '../../../components';
import { docusignAuthStateKey } from './DocusignAuthHelpers';
import { requestAuthToken } from './utils';

export interface DocusignAuthLoginEndProps {
    state: string;
    code: string;
}

export const DocusignAuthLoginEnd: React.FC<DocusignAuthLoginEndProps> = (
    props: DocusignAuthLoginEndProps
): JSX.Element => {
    const logger = getAppHost().getLogger();
    const logCategory = LogCategory.DocusignAuth;
    logger.logTraceInfo(logCategory, 'Calling AuthLoginEnd');

    const fetchDocusignAuthToken = (): void => {
        if (getStoredState() !== props.state) {
            logger.logTraceError(logCategory, 'Invalid state received from DocuSign');
            throw new Error('Invalid state returned from request.');
        }

        requestAuthToken(ApprovalRequestType.Docusign, props.code);
    };

    React.useEffect((): void => fetchDocusignAuthToken(), []);
    return (
        <div style={{ height: '100vh' }}>
            <Spinner />
        </div>
    );
};

function getStoredState(): string {
    const storedSated = localStorage.getItem(docusignAuthStateKey);
    localStorage.removeItem(docusignAuthStateKey);
    return storedSated;
}
